/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["nb-layout-column[_ngcontent-%COMP%]{padding:0!important}.nav-bar[_ngcontent-%COMP%]{display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center;width:8rem;height:2.5rem;color:#a7b1c2;font-weight:700;font-size:1rem;cursor:pointer}.nav-bar.active[_ngcontent-%COMP%]{background-color:#ffecdc;color:#041a30}.nav-item[_ngcontent-%COMP%]:focus{outline:0!important}"];
export { styles as styles };
